export default "__VITE_ASSET__DDMciByF__"